import Swiper, { Navigation, Pagination } from 'swiper/bundle';
var deviceDetection = require('./deviceDetection');

Swiper.use([Navigation, Pagination]);

/**
 * Hides Swiper navigation and pagination if there are fewer slides than slidesPerView.
 * @param {Object} e - The Swiper instance.
 */
function handleSwiperNavigation(e) {
    const realSlides = e.slides.filter(slide => !slide.classList.contains('swiper-slide-duplicate'));

    if (e.params.slidesPerView >= realSlides.length) {
        if (e.navigation && e.navigation.nextEl) {
            $(e.navigation.nextEl).addClass('swiper-button-hidden');
        }
        if (e.navigation && e.navigation.prevEl) {
            $(e.navigation.prevEl).addClass('swiper-button-hidden');
        }
        if (e.pagination && e.pagination.el) {
            $(e.pagination.el).addClass('swiper-pagination-hidden');
        }
    } else {
        if (e.navigation && e.navigation.nextEl) {
            $(e.navigation.nextEl).removeClass('swiper-button-hidden');
        }
        if (e.navigation && e.navigation.prevEl) {
            $(e.navigation.prevEl).removeClass('swiper-button-hidden');
        }
        if (e.pagination && e.pagination.el) {
            $(e.pagination.el).removeClass('swiper-pagination-hidden');
        }
    }
}

/**
 * Updates the Swiper instance and its pagination if available.
 *
 * @param {Object} e - The Swiper instance.
 */
function updateSwiperAndPagination(e) {
    if (typeof e.update === 'function') {
        e.update();
    }
    if (e.pagination && typeof e.pagination.render === 'function') {
        e.pagination.render();
        if (typeof e.pagination.update === 'function') {
            e.pagination.update();
        }
    }
}

/**
 * Initializes a Swiper carousel for the promotional section.
 *
 * This function creates a new Swiper instance targeting the `.swiper-container` element.
 * It sets up looping, slide spacing, navigation buttons, and clickable pagination.
 *
 * Requirements:
 * - The Swiper library must be included in the project.
 * - The HTML structure must include:
 *   - A container with class `.swiper-container`
 *   - Navigation buttons with classes `.swiper-button-next` and `.swiper-button-prev`
 *   - A pagination element with class `.swiper-pagination`
 *
 * @function
 * @returns {void}
 */
function initCarousel() {
   
    var defaultOptions = {
        loop: true,
        slidesPerView: 1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        }
    };
    
    var customSlidersList = {
        'swiper-promo': {
            slidesPerView: 1,
            slidesPerScroll: 1,
            autoplay: {
                delay: 5000
            },
            autoHeight: true,
            on: {
                slideChange: function () {
                    if ($('#searchModal').hasClass('show')) {
                        $('body').trigger('header:updateHeaderOffset', [true]);
                    } else {
                        $('body').trigger('header:updateHeaderOffset');
                    }
                }
            }
        },
        'swiper-products': {
            slidesPerView: 2,
            slidesPerScroll: 1,
            spaceBetween: 16,
            slidesPerGroup: 2,
            autoHeight: true,
            loop: false,
            pagination: {
                el: '.swiper-pagination',
                dynamicBullets: true,
                clickable: true
            }
        },
        'swiper-cart-recommendations': {
            slidesPerView: 4,
            slidesPerScroll: 1,
            loop: true,
            breakpoints: {
                0: {
                    slidesPerView: 2,
                    slidesPerGroup: 2
                },
                768: {
                    slidesPerView: 4,
                    slidesPerGroup: 4
                },
            },
            on: {
                // Initial load
                init: function (e) {
                    handleSwiperNavigation(e);
                },
                // Optional but recommended for breakpoint changes
                resize: function (e) {
                    handleSwiperNavigation(e);
                    updateSwiperAndPagination(e);
                },
                breakpointChange: function (e) {
                    handleSwiperNavigation(e);
                    updateSwiperAndPagination(e);
                }
            }
        },
        'ibc-featured-products-swiper': {
            slidesPerView: 2,
            slidesPerScroll: 1,
            spaceBetween: 16,
            slidesPerGroup: 2,
            loop: false,
            autoHeight: true,
            pagination: {
                el: '.swiper-pagination',
                clickable: true
            }
        }

    };
    
    $('body').find('.swiper-container, .swiper').each(function () {
        var $el = $(this);
        var matchedClass = null;
    
        $.each(customSlidersList, function (className) {
            if ($el.hasClass(className)) {
                matchedClass = className;
                return false;
            }
            return true;
        });
    
        var options = matchedClass
            ? $.extend(true, {}, defaultOptions, customSlidersList[matchedClass])
            : defaultOptions;

        // Special handling: for the IBC featured-products slider we want
        // a static grid on desktop and a Swiper carousel on mobile/tablet.
        // Initialize/destroy Swiper responsively using device detection.
        if (matchedClass === 'ibc-featured-products-swiper') {
            var swiperInstance = null;

            var initOrDestroy = function () {
                var isMobileView = deviceDetection.isPhone();
                if (isMobileView && !swiperInstance) {
                    // initialize Swiper for mobile/tablet
                    swiperInstance = new Swiper($el[0], options); // eslint-disable-line
                    $el.data('swiperInstance', swiperInstance);
                } else if (!isMobileView && swiperInstance) {
                    // destroy Swiper for desktop so markup becomes a static grid
                    try {
                        swiperInstance.destroy(true, true);
                    } catch (e) {
                        // ignore
                    }
                    swiperInstance = null;
                    $el.removeData('swiperInstance');
                }
            };

            // Run once to set initial state
            initOrDestroy();

            // Debounced resize handler
            var resizeTimeout = null;
            var onResize = function () {
                if (resizeTimeout) {
                    clearTimeout(resizeTimeout);
                }
                resizeTimeout = setTimeout(function () {
                    initOrDestroy();
                }, 150);
            };

            $(window).on('resize', onResize);
        } else {
            new Swiper($el[0], options); // eslint-disable-line
        }
    });    
}

export default initCarousel;
